import React, { useState, useEffect, useRef } from "react";
import { apiCallGeneric } from "../../../services/api-service.js";
import { ReactComponent as ArrowDownIcon } from "../../../assets/svg/arrow-down.svg";
import { ReactComponent as ArrowUpIcon } from "../../../assets/svg/arrow-up.svg";

import { FaCheck } from "react-icons/fa";

    const MultiSelectDropDown = ({searchId=-1,  onDropdownChange, apiUrl, placeholder, selectedValue,selectedOption,params={}, staticOptions=[] }) => {
      const [isOpen, setIsOpen] = useState(false);
      const [searchTerm, setSearchTerm] = useState("");
      const [options, setOptions] = useState([]);
      const [filteredOptions, setFilteredOptions] = useState([]);
     /*  const [selectedOption, setSelectedOption] = useState(null); */
      const [loading, setLoading] = useState(false);
      const [error, setError] = useState(null);
      const dropdownRef = useRef(null);
    
      const getQueryParamsAsObject = (url) => {
        const urlObj = new URL(url);
        const params = new URLSearchParams(urlObj.search);
        return Object.fromEntries(params.entries()); // Convert to object
      };

      // Mock API call to fetch options
      const fetchOptions = async () => {
        setLoading(true);
        setError(null);
        try {
          if(apiUrl!==undefined && apiUrl!==""){
           /*  const paramsFromUrl=getQueryParamsAsObject(apiUrl); */
          
            params["term"]=searchTerm;
           await apiCallGeneric("GET", apiUrl.split('?')[0], null, {
            params: params??{},
          }).then((response) => {
            if(response.status===200){
                if (response.data.success === true) {
                 
          setOptions(response.data.suggestionlist); 
          setFilteredOptions(response.data.suggestionlist);                 
                }else{
                  setOptions([]); 
                  setFilteredOptions([]);  
                }
            }
          });
    
        
        }else{
          if (searchTerm === "") {
           
          } else {
            setFilteredOptions(
              options.filter((option) =>
                option.label.toLowerCase().includes(searchTerm?.toLowerCase())
              )
            );
          }
        }
        } catch (err) {
          console.error("Error fetching options:", err);
          setError("No options found.");
        } finally {
          setLoading(false);
        }
      };
    
      // Fetch options when component mounts or search term changes
      useEffect(() => {
        fetchOptions();
      }, [searchTerm]);
    
      // Filter options based on search term and selectedOption
      useEffect(() => {
        let result = [];
        if (searchTerm === "") {
          result = [...options];
        } else {
          result = options.filter((option) =>
            option?.label?.toLowerCase().includes(searchTerm?.toLowerCase())
          );
        }

        if (selectedOption && Array.isArray(selectedOption)) {
          const selectedValues = selectedOption
            .filter(item => item && item.value !== '')
            .map(item => item.value);

          result.sort((a, b) => {
            const aSelected = selectedValues.includes(a.value);
            const bSelected = selectedValues.includes(b.value);
            if (aSelected && !bSelected) return -1;
            if (!aSelected && bSelected) return 1;
            return 0;
          });
        }
        setFilteredOptions(result);
      }, [searchTerm, options, selectedOption]);
    
      // Handle outside click to close the dropdown
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
    
      useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);
    
      const toggleDropdown = () =>{
         setIsOpen((prev) => !prev);
         if(!isOpen){
          if(apiUrl===undefined || apiUrl===""){
          setOptions(staticOptions)
          }
          fetchOptions();
         }
         }
    
      const selectOption = (option) => {
        /* setSelectedOption(option); */
        if(searchId===-1){
          onDropdownChange(option);
        }else{
          onDropdownChange(option, searchId);
        }
        /* setIsOpen(false); */
      };
    
      return (
        <div ref={dropdownRef} style={{ position: "relative",  height:"40px" }}>
          {/* Dropdown Header */}
          <div
            onClick={toggleDropdown}
            style={{
              height:"40px",
              padding: "10px",
              border: isOpen?"1px solid #6929E2":"1px solid #E5E5E5",
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              background: "#FFFFFF",
              color:selectedOption.length>0 ?'#1E1E1E':'#81878C'
            }}
          >
           <span style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",}}> {selectedOption.filter(item => item.value !=='').length>0 ? selectedOption.filter(item => item.value !=='').map((item) => item.label).join(', ') : placeholder }</span>
            <span style={{ marginLeft: "10px" }}>{isOpen ? <ArrowUpIcon/> : <ArrowDownIcon/>}</span>
          </div>
    
          {/* Dropdown Options */}
          {isOpen && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                border: "1px solid #ccc",
                borderRadius: "4px",
                background: "#fff",
                zIndex: 1000,
                maxHeight: "200px",
                overflowY: "auto",
              }}
            >
              {/* Search Input */}
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search..."
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "none",
                  borderBottom: "1px solid #ccc",
                  boxSizing: "border-box",
                  color:'#1E1E1E'
                }}
              />
    
              {/* Options */}
              {loading ? (
                <div style={{ padding: "10px", textAlign: "center" }}>Loading...</div>
              ) : error ? (
                <div style={{ padding: "10px", textAlign: "center", color: "red" }}>
                  {error}
                </div>
              ) : filteredOptions.length > 0 ? (
                filteredOptions.map((option, index) => {
                  const isSelected = selectedOption && selectedOption.some(sOption => sOption.value === option.value);
                  return (
                    <div
                      key={index}
                      onClick={() => selectOption(option)}
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        background: isSelected ? "#f0f0f0" : "#fff",
                        color: '#1E1E1E',
                        textAlign: "left",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                      }}
                    >
                      <span>{option.label}</span>
                      {isSelected && (
                        <FaCheck style={{ color: "#2C8C53", fontSize: "12px" }} />
                      )}
                    </div>
                  );
                })
              ) : (
                <div style={{ padding: "10px", textAlign: "center" }}>
                  No records found.
                </div>
              )}
            </div>
          )}
        </div>
      );
    };
    
    export default MultiSelectDropDown;
  